module.exports = __webpack_public_path__ + "static/media/goodfit.72bdb82a.png";